<template>
  <div class="">
    <Nav />
    <div v-cloak>
      <div class="container-fluid main-container px-0 mt-4 mt-lg-4 mt-xl-5">
        <div class="d-flex flex-column flex-lg-row mp">
          <div class="col-lg-6 col-xl-6">
            <div class="row">
              <div class="col-12 offset-lg-2 col-lg-10">
                <h1 class="mp__title">
                  Nawłoć kanadyjska przejmuje nasze łąki. Nie pozwólmy na to!
                </h1>
                <div class="mp__text">
                  Nawłoć kanadyjska to roślina inwazyjna, która niszczy nasze
                  łąki. Mimo że potrafi pięknie wyglądać,
                  <strong>
                    jest zabójcza dla rodzimych roślin łąkowych i
                    zapylaczy</strong
                  >. Tempo jej wzrostu sprawia, że dusi inne rośliny i nie daje
                  im przestrzeni do życia. Łąki, które kiedyś tętniły życiem i
                  wielością gatunków, po inwazji nawłoci zamieniają się w
                  monokulturę - nawłoć potrafi całkowicie zdominować przestrzeń,
                  w której rośnie.
                  <strong>
                    Znikają rodzime gatunki roślin łąkowych a z nimi związane z
                    nimi zapylacze.</strong
                  >
                  Zostaje morze nawłoci... <br /><br />
                  Dlatego
                  <strong>
                    należy ją usuwać, szczególnie jeśli występuje w okolicach
                    dzikich, naturalnych łąk i terenów cennych
                    przyrodniczo.</strong
                  >
                  Dodając stanowisko nawłoci do mapy, dostaniesz informację, kiedy to zrobić skutecznie. Dostaniesz przypomnienie mailowe lub smsowe (możesz wybrać oba!) w
                  momencie, gdy będzie najlepszy moment na jej usuwanie. A więcej o nawłoci, o tym, jak ją rozpoznać, dlaczego jest takim dużym problemem i jak ją usuwać, możesz przeczytać, klikając w link poniżej:
                </div>
              </div>
              <div class="col-12 offset-lg-2 col-lg-10 text-center py-4">
                <a href="https://www.greenpeace.org/poland/nawloc/" target="_blank" class="mp__info-btn btn">
                 Dowiedz się więcej o nawłoci &raquo;
                </a>
              </div>
              <div
                class="col-12 d-flex flex-column offset-lg-2 col-lg-10 flex-xl-row justify-content-lg-between "
              >
                <div class="mr-xl-2"  v-for="(image, index) in images"
                :key="index">               
                  <img
                    :src="image.src"
                    class="mp__img"
                    alt="Nawłoć"
                     @click="showImage(index)"
              
                  />
                </div>
              </div>
              <div v-if="selectedImage" class="lightbox" @click="closeImage">
                <span class="lightbox-close" @click="closeImage">ZAMKNIJ</span>
                <img :src="selectedImage.src" class="large-image" />
              </div>
              <div class="col-12 offset-lg-2 col-lg-10">
                <div class="mp__text text-center w-100 mb-2">
                  Różne fazy rozwoju nawłoci kanadyjskiej
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-6 text--center">
            <div class="container">
              <PointsMap />
              
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import PointsMap from "@/components/PointsMap.vue";
import Nav from "@/components/Nav.vue";
import Footer from "@/components/Footer.vue";
import img_1 from "@/assets/images/nawloc/nawloc_3.jpg";
import img_2 from "@/assets/images/nawloc/nawloc_2.webp";
import img_3 from "@/assets/images/nawloc/nawloc_1.jpg";

export default {
  name: "MainPageComponents",
  inject: ["content"],
  components: {
    PointsMap,
    Nav,
    Footer,
  },
  data() {
    return {
      isLoading: false,
      image_1: img_1,
      image_2: img_2,
      image_3: img_3,
      images: [
        {
          src: img_1,
        },
        {
          src: img_2,
        },
        {
          src: img_3,
        },
      ],
      selectedImage: null,
      
    };
  },
  computed: {},

  methods: {
    showImage(index) {
      console.log(index);
      this.selectedImage = this.images[index];
    },
    closeImage() {
      this.selectedImage = null;
    },
  },
  watch: {},
};
</script>
